import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import api from 'services/api';
import swal from 'sweetalert';

import { Creators as JourneysActions, Types as JourneysTypes } from 'store/ducks/journeys';

function* getJourneysRequest(action) {
  try {
    const { page, query } = action.payload;
    const filter = query !== null ? `&filter=${query}` : '';
    const url = `search/journeys/page?page=${page}&per=25${filter}`;
    const response = yield call(api.get, url);

    yield put(JourneysActions.getJourneysSuccess(response.data));
  } catch (error) {
    yield put(JourneysActions.getJourneysFailure());
  }
}

function* getJourneyRequest(action) {
  try {
    const { id } = action.payload;
    const url = `search/journeys/${id}`;
    const response = yield call(api.get, url);

    yield put(JourneysActions.getJourneySuccess(response.data));
  } catch (error) {
    yield call(swal, 'Não encontrado', 'Não encontramos a jornada!', 'error');
    yield put(JourneysActions.getJourneyFailure());
  }
}

function* updateJourneyRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `search/journeys/${id}`;
    yield call(api.put, url, data);

    yield call(swal, 'Succeso', 'Jornada atualizada com sucesso!', 'success');
    yield put(push('/admin/journeys'));
    yield put(JourneysActions.updateJourneySuccess());
  } catch (error) {
    yield call(swal, 'Ops Falha', 'Não foi possível atualizar a jornada!', 'error');
    yield put(JourneysActions.updateJourneyFailure());
  }
}

function* createJourneyRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'search/journeys';
    yield call(api.post, url, data);

    yield call(swal, 'Succeso', 'Jornada criada com sucesso!', 'success');
    yield put(push('/admin/journeys'));
    yield put(JourneysActions.createJourneySuccess());
  } catch (error) {
    yield call(swal, 'Ops Falha', 'Não foi possível criar a jornada', 'error');
    yield put(JourneysActions.createJourneyFailure());
  }
}

export default function* saga() {
  yield takeLatest(JourneysTypes.GET_LIST_REQUEST, getJourneysRequest);
  yield takeLatest(JourneysTypes.GET_REQUEST, getJourneyRequest);
  yield takeLatest(JourneysTypes.UPDATE_REQUEST, updateJourneyRequest);
  yield takeLatest(JourneysTypes.CREATE_REQUEST, createJourneyRequest);
}



// WEBPACK FOOTER //
// ./src/store/sagas/journeys.js